import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "../layouts/Main";
import Home from "../pages/Home/Home";
import PACheck from '../pages/PACheck/PACheck';
import PACheckResults from '../pages/PACheckResults/PACheckResults';
import { stringConstants } from "../constants/stringConstants";
import NotFound from "../pages/NotFound";
import CommonSnackbar from '../components/CommonSnackbar';
import { useStoreState, useStoreActions } from "easy-peasy";

const AppRoutes = () => {
  const snackbar = useStoreState((state) => state.common.snackbar);
  const commonAction = useStoreActions((actions) => actions.common);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    commonAction.setSubmitSnackbar({
      open: false,
      status: false,
      messages: '',
    });
  };

  return (
    <>
      <Router>
        <Routes>
          <Route path="/">
            <Route index element={<Home />} />
          </Route>

          <Route path={`/:orgId/${stringConstants.PA_CHECK_FORM_URL}`} element={<Main />}>
            <Route index element={<PACheck />} />
          </Route>

          <Route path={`/:orgId/${stringConstants.PA_CHECK_RESULTS_URL}`} element={<Main />}>
            <Route index element={<PACheckResults />} />
          </Route>

          {/* Global NotFound inside Main layout */}
          <Route path="*" element={<Main />}>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
      {/* Snackbar Toast */}
      {snackbar.open && (
        <CommonSnackbar
          open={snackbar.open}
          onClose={handleClose}
          message={snackbar.messages}
          type={snackbar.status ? "success" : "error"}
        />
      )}
    </>
  );
};

export default AppRoutes;
